export const parseCurrency = (value, currency = 'VND', type = 'it-IT') => {
  const test = currency.length === 0;
  if (!test) {
    return parseInt(value || 0).toLocaleString(type, {
      style: 'currency',
      currency,
    });
  } else {
    return parseInt(value || 0).toLocaleString(type);
  }
};
